import type {ReactElement} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import styles from './contextual-menu-divider.module.scss';

interface ContextualMenuDividerProps {
  id: string;
  className?: string;
}

export function ContextualMenuDivider({className = '', ...props}: ContextualMenuDividerProps): ReactElement<any> | null {
  return <Option key={props.id} optionControl={<div className={styles.divider} />} className={className} />;
}
